import { SITE } from "@/lib/site";

export default function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <section
      data-testid="page-hero"
      className="relative bg-[var(--trj-navy)] text-white overflow-hidden"
    >
      {image && (
        <div className="absolute inset-0 opacity-30">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1F3A] via-[#0B1F3A]/85 to-[#0B1F3A]/40" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-6 py-24 md:py-32">
        {eyebrow && <div className="trj-eyebrow mb-4">{eyebrow}</div>}
        <h1 className="font-serif-trj text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-white/75 text-base md:text-lg max-w-2xl leading-relaxed font-body-trj">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-9 flex flex-wrap gap-3">{children}</div>}
      </div>
      <div className="relative">
        <div className="gold-rule" />
      </div>
    </section>
  );
}

export function CTAButtons({ children }) {
  return <div className="flex flex-wrap gap-3">{children}</div>;
}

export function ScheduleConsultationButton({ variant = "green", testid = "schedule-consultation-btn", label = "Schedule Consultation", calendlyOverride }) {
  const cls = variant === "gold" ? "trj-btn-gold" : "trj-btn-green";
  const href = calendlyOverride || SITE.calendlyUrl;
  return (
    <a href={href} target="_blank" rel="noreferrer" className={cls} data-testid={testid}>
      {label}
    </a>
  );
}
